import { render, staticRenderFns } from "./VeeObjectEdit.vue?vue&type=template&id=6e735dbb&"
import script from "./VeeObjectEdit.vue?vue&type=script&lang=js&"
export * from "./VeeObjectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports